<!-- <div class="content-area"> -->

<xproj-dashboard #dashboard [class.fullscreen]="fullScreenRequested" [editMode]="(currentUserRights.isCustomerAdmin || currentUserRights.isAdminUser ) && editModeRequested" [showDashboardSettings]="false" [dashboardId]="dashboardId" [enableExport]="true"
    (onWidgetExport)="onWidgetExport($event)" [dashboardOutputParameters]="dashboardOutputParameters" [responsiveWidth]="responsiveWidth" onresize="onResize($event)"></xproj-dashboard>

<!-- </div> -->